import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'all',
    size: 20,
  },
};

const waitMasterInitialState = {
  loadStatus: 0,
  list: null,
  count: 0,
};

const detailInitialState = {
  loadStatus: 0,
  saveStatus: 0,
};

const themeBannerInitialState = {
  loadStatus: 0,
  list: null
}

const themeListInitialState = {
  loadStatus: null,
  list: null
}

const themeTipInitialState = {
  loadStatus: 0,
  show: false,
}

function groupsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_GROUP_COMPLETION': {
      const { data, error } = action;
      const { groupId } = data;

      if (error) {
        return state;
      }

      return {
        ...state,
        [groupId]: data,
      };
    }

    case 'LOAD_GROUP_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const groups = action.list.reduce(
        (obj, group) => {
          const groupId = group.groupId;

          if (groupId) {
            obj[groupId] = { ...obj[groupId], ...group };
          }
          return obj;
        },
        { ...state }
      );

      return groups;
    }

    default:
      return state;
  }
}

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_GROUP_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(group => group.groupId);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function waitMasterReducer(state = waitMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP_WAIT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        list: null,
        count: 0,
      };
    }

    case 'LOAD_GROUP_WAIT_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: action.list,
        count: action.count,
      };
    }

    default:
      return state;
  }
}

function detailReducer(state = detailInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_GROUP_COMPLETION': {
      const { data, error } = action;
      const { groupId } = data;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        id: groupId,
        loadStatus: 2,
      };
    }

    case 'OVER_GROUP': {
      return {
        ...state,
        saveStatus: 1,
      }
    }

    case 'OVER_GROUP_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
      };
    }

    default:
      return state;
  }
}

function themeBannerReducer(state = themeBannerInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP_THEME_BANNER_LIST': {
      return {
        ...state,
        loadStatus: 1
      }
    }
    case 'LOAD_GROUP_THEME_BANNER_LIST_COMPLETION': {
      const { error, list } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0
        }
      }

      return {
        ...state,
        loadStatus: 2,
        list
      }
    }
    default:
      return state
  }
}

function themeListReducer(state = themeListInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP_THEME_LIST': {
      return {
        ...state,
        loadStatus: 1
      }
    }
    case 'LOAD_GROUP_THEME_LIST_COMPLETION': {
      let { error, list } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0
        }
      }

      return {
        ...state,
        loadStatus: 2,
        list: list || null
      }
    }
    default:
      return state
  }
}

function themeTipReducer(state = themeTipInitialState, action) {
  switch (action.type) {
    case 'LOAD_GROUP_THEME_TIP_SHOW': {
      return {
        ...state,
        loadStatus: 1
      }
    }
    case 'LOAD_GROUP_THEME_TIP_SHOW_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0
        }
      }

      return {
        ...state,
        loadStatus: 2,
        show: data
      }
    }
    case 'SYNC_GROUP_THEME_TIP_SHOW': {
      return {
        ...state,
        ...action.value
      }
    }
    default:
      return state
  }
}

export default combineReducers({
  groups: groupsReducer,
  master: masterReducer,
  detail: detailReducer,
  waitMaster: waitMasterReducer,
  theme: combineReducers({
    banner: themeBannerReducer,
    list: themeListReducer,
    tip: themeTipReducer
  })
});
